import {
  PATH_TO_USERS_STATE,
  usersReducer
} from "seneca-common/features/users/state";
import ReducerRegistry from "seneca-common/utils/state/reducer-registry";

import { PATH_TO_STUDENT_PARENTS_STATE } from "./consts";
import parentDetailsReducer from "./reducers";
import usersReducerWrapper from "./reducers/usersReducerWrapper";

const reducerRegistry = ReducerRegistry.getInstance();
reducerRegistry.initialise(PATH_TO_STUDENT_PARENTS_STATE, builder => {
  builder
    .register(PATH_TO_STUDENT_PARENTS_STATE, parentDetailsReducer)
    .enhance(PATH_TO_USERS_STATE, usersReducer, usersReducerWrapper);
});

//actions
export {
  fetchStudentParentsActionFactory,
  updateStudentParentsActionFactory
} from "./actions/meta";
export { receiveParents, receiveParent, deleteParent } from "./actions";

//selectors
export {
  getStudentParentIds,
  isParentLinked,
  getParentIdByCode,
  studentAlreadyLinkedToParent, //meta
  studentParentsNeedFetching,
  studentParentsFetchFinished,
  studentParentsFetchErrored,
  studentParentsFetchSucceeded,
  studentParentsAreFetching,
  studentParentIsUpdating,
  studentParentUpdateSucceeded,
  studentParentUpdateErrored,
  studentParentUpdateFinished,
  studentParentUpdateErrorMessage,
  userAttemptsToConnectToOwnAccount
} from "./selectors";
